export const BUDDY_TEXTS = {
	name: 'Buddy',
	subtitle: 'Your assistant',
	connected: 'Online · Ready to help',
	inputPlaceholder: 'Ask about drivers, rides, routes…',
	openFullView: 'Open full view',
	newConversation: 'New conversation',
	close: 'Close',
	send: 'Send',
};
